<script>
import ForwardButton from "@/components/ForwardButton";
import BackwardButton from "@/components/BackwardButton";
import Tooltip from "../../components/tooltip/Tooltip.vue";
import vSelect from "vue-select";
import { keys, set, get } from "lodash";
import axios from "axios";

export default {
  name: "Diversity",
  components: {
    ForwardButton,
    BackwardButton,
    vSelect,
    Tooltip,
  },
  data: () => ({
    diversity_popup: false,
    skin_color_popup: false,
    egression_popup: false,
    PCD_popup: false,
    medical_report_removal_popup: false,
    options: [],
    payload: {
      gender: null,
      breed_id: null,
      is_egression: false,
      pcd_reability: false,
      disabilities_id: [],
    },
    errors: {
      gender: "",
      breed_id: "",
      is_egression: "",
      pcd_reability: "",
      disabilities_id: "",
    },
    jobPositionReference: localStorage.getItem("vacancy_name"),
    gender_tooltip:
      "Ao pedir sua identidade de gênero durante o processo seletivo, garantimos a inclusão e diversidade no ambiente de trabalho. Além disso, isso pode ajudar a empresa a entender melhor a composição da sua força de trabalho, o que pode ser útil para estabelecer políticas e programas que promovam a diversidade e inclusão.",
    pcd_tooltip:
      "Durante o processo de seleção, perguntamos se você tem alguma deficiência para garantir que nosso ambiente de trabalho seja acessível para todos. Isso nos ajuda a cumprir a lei de cotas para pessoas com deficiência e a identificar quaisquer barreiras de acessibilidade que possam existir. Uma pessoa com deficiência reabilitada é alguém que passou pelo processo de reabilitação pelo INSS com sucesso e foi considerada apta a retornar ao mercado de trabalho.",
    skin_color_tooltip:
      "Pedir a sua cor durante o processo seletivo é uma forma de coletar informações sobre a diversidade étnico-racial da empresa e do seu quadro de colaboradores. Isso permite que a empresa possa identificar eventuais desigualdades e lacunas em sua força de trabalho e, a partir dessas informações, desenvolver políticas e ações afirmativas para promover a inclusão social e a diversidade em seu ambiente de trabalho.",
    rehabilitated_tooltip:
      "Pessoa egressa é quem saiu recentemente da prisão e pré-egressa é quem ainda está cumprindo pena, mas está em processo de reintegração na sociedade. Coletar informações sobre essas pessoas no processo seletivo é importante para promover a inclusão e diversidade no ambiente de trabalho, além de contribuir para reduzir preconceitos e discriminação.",
    has_disabilities: "0",
    medical_report_file: undefined,
    medical_report_list: [],
    allowUpload: false,
  }),
  computed: {
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },
    egressed: {
      get() {
        return this.$store.state.diversity.egressed;
      },
      set(value) {
        this.$store.commit("diversity/ON_EGRESSED", value);
      },
    },
    talent_uuid() {
      return this.$store.state.basicInfo.basicInfo.talent_uuid;
    }
  },
  watch: {
    has_disabilities(newVal) {
      if(newVal === "0") {
        this.payload.disabilities_id = [];
        this.payload.pcd_reability = false;
      }
    },
  },
  methods: {
    isEdit() {
      return this.$router.history.current.path.includes('edit')
    },
    handleCloseDiversity() {
      this.diversity_popup = false
    },
    handleOpenDiversity() {
      this.diversity_popup = true
    },
    handleCloseSkinColor() {
      this.skin_color_popup = false
    },
    handleOpenSkinColor() {
      this.skin_color_popup = true
    },
    handleCloseEgression() {
      this.egression_popup = false
    },
    handleOpenEgression() {
      this.egression_popup = true
    },
    handleClosePCD() {
      this.PCD_popup = false
    },
    handleOpenPCD() {
      this.PCD_popup = true
    },
    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },
    handleBackward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail",
        });
        return;
      }

      this.$store.dispatch("step/decrementCurrentStep");
      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params,
      });
    },
    async handleForward() {
      // Check if user has no disabilities selected but has medical reports uploaded
      if ((this.has_disabilities === "0" || this.payload.disabilities_id.length === 0) && this.medical_report_list.length > 0) {
        this.medical_report_removal_popup = true;
        return;
      }
      
      await this.saveFormData();
    },
    async saveFormData() {
      this.$vs.loading();
      
      // If user selected "No" for disabilities, remove all medical reports before saving
      if (this.has_disabilities === "0" || this.payload.disabilities_id.length === 0) {
        await this.removeAllMedicalReports();
      }
      
      this.$http
        .post("/api/v1/diversity", this.payload)
        .then(async (response) => {
          this.$vs.loading.close();

          await this.$store.dispatch("diversity/addDiversity", response.data);

          set(this.payload, "gender", this.$store.state.diversity.gender);

          if (this.onEditMode()) {
            this.$router.push({
              name: "dashboard-profile-detail",
            });
            return;
          }
          
          await this.$store.dispatch("step/completeStep");
          await this.$store.dispatch("step/incrementCurrentStep");

          const step = this.$store.getters["step/current"];
          const { params } = this.$router.history.current;

          this.$router.push({
            name: step.path,
            params,
          });
        })
        .catch((error) => {
          get(error, 'response.data.errors', []).forEach((item) => {
            const { key, errors } = item;
            this.errors[key] = errors;
          });
          this.$vs.loading.close();
        });
    },
    async confirmRemoveMedicalReports() {
      this.medical_report_removal_popup = false;
      await this.saveFormData();
    },
    cancelRemoveMedicalReports() {
      this.medical_report_removal_popup = false;
    },
    removeAllMedicalReports: async function () {
      if (this.medical_report_list.length === 0) {
        return;
      }

      try {
        const token = localStorage.getItem("userToken");
        
        // Remove all medical reports
        await Promise.all(
          this.medical_report_list.map(report => 
            axios.delete(
              `${process.env.VUE_APP_API_BASE_URL.replace(/\/+$/, "")}/api/v2/talents/files/medical-report/${report.uuid}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
          )
        );

        // Track removal for analytics
        this.medical_report_list.forEach(report => {
          window.woopra.track("medical-report-removed", {
            talent_uuid: this.talent_uuid,
            report_uuid: report.uuid,
          });
        });

        // Clear the list and refresh
        this.medical_report_list = [];
        this.allowUpload = true;
        
      } catch (error) {
        console.error("Error removing medical reports:", error);
      }
    },
    fetchDiversityOptionsRequest() {
      this.$vs.loading();

      this.$http
        .get("/api/v1/diversity?debug=true")
        .then((response) => {
          const { data = [] } = response;

          const dataKeys = keys(data);

          const options = {};

          dataKeys.forEach((key) => {
            set(
              options,
              key,
              data[key].map((item) => ({
                label: item.name,
                value: item.id,
                description: item.description ? item.description : null,
              }))
            );
          });

          const {
            gender,
            breed,
            is_egression,
            pcd_reability,
            deficiencies,
          } = this.$store.state.diversity;

          const genderId = gender != null && typeof gender === 'object' ? gender.id : gender;
          set(this.payload, "gender", genderId);

          if (breed && breed.id) {
            set(this.payload, "breed_id", breed.id);
          }

          if (is_egression !== null) {
            set(this.payload, "is_egression", is_egression);
          }

          if (pcd_reability !== null) {
            set(this.payload, "pcd_reability", pcd_reability);
            if (pcd_reability === true) {
              this.has_disabilities = "1";
            }
          }

          if (deficiencies && deficiencies.length > 0) {
            set(
              this.payload,
              "disabilities_id",
              deficiencies.map((item) => item.id)
            );
            this.has_disabilities = "1";
          }

          this.options = options;

          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    onDisabilities(disabilityId) {
      if (!this.payload.disabilities_id.includes(disabilityId)) {
        this.payload.disabilities_id = [...this.payload.disabilities_id, disabilityId];
        return;
      }

      if (this.payload.disabilities_id.includes(disabilityId)) {
        this.payload.disabilities_id = this.payload.disabilities_id.filter(
          (el) => el != disabilityId
        );
        return;
      }
    },
    handleMedicalReportUpload: function () {
      this.allowUpload = false;
      this.$vs.loading({
        text: "Enviando...",
      });
      
      const file = this.$refs.medical_report_file.files[0];
      const formData = new FormData();

      formData.append("file", file);
      formData.append("title", file.name)

      const token = localStorage.getItem("userToken");
      
      if (!this.talent_uuid) {
        this.$vs.notify({
          title: "Falha ao enviar laudo médico",
          text: "Recarregue a página e tente novamente",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
        this.allowUpload = true;
        this.$vs.loading.close();
        return;
      }
      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL.replace(/\/+$/, "")}/api/v2/talents/files/medical-report/${this.talent_uuid}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          this.$vs.loading.close();
          this.allowUpload = false;
          this.$vs.notify({
            title: `Sucesso!`,
            text: "Seu laudo médico foi enviado com sucesso!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          })

          window.woopra.track("medical-report-uploaded", {
            talent_uuid: this.talent_uuid,
            file_name: file.name,
            link: get(response, 'data.data.link'),
          });
        })
        .catch((error) => {
          this.allowUpload = true;
          this.$vs.loading.close();
          this.$vs.notify({
            title: `Falha ao enviar o laudo médico. ${get(error, 'response.data.message','')}`,
            text: "Ocorreu um erro ao enviar o laudo médico. Atualize a página e tente novamente!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        })
        .finally(()=>this.fetchMedicalReports());
    },
    fetchMedicalReports: async function () {
      this.$vs.loading(
        {
          text: 'Carregando Laudos Médicos'
        }
      )
      try {
        const token = localStorage.getItem("userToken");
        const response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL.replace(/\/+$/, "")}/api/v2/talents/files/medical-report/${this.talent_uuid}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        if (response.status !== 200) {
          this.medical_report_list = [];
          return;
        }
        const data = get(response, 'data.data');
        if (data && data.length > 0) {
          this.medical_report_list = data;
          this.allowUpload = false;
        } else {
          this.medical_report_list = [];
          this.allowUpload = true;
        }
      }
      catch (error) {
        console.error(error);
      }
      finally {
        this.$vs.loading.close();
      }
    },
    removeMedicalReport: async function (uuid) {
      this.$vs.loading({
        text: "Removendo laudo médico..."
      });

      try {
        const token = localStorage.getItem("userToken");
        
        await axios.delete(
          `${process.env.VUE_APP_API_BASE_URL.replace(/\/+$/, "")}/api/v2/talents/files/medical-report/${uuid}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        this.$vs.notify({
          title: "Sucesso",
          text: "Laudo médico removido com sucesso!",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });

        window.woopra.track("medical-report-removed", {
          talent_uuid: this.talent_uuid,
          report_uuid: uuid,
        });

      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Erro ao remover laudo médico",
          text: "Ocorreu um erro ao remover o laudo médico. Por favor, tente novamente.",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
      } finally {
        this.$vs.loading.close();
        await this.fetchMedicalReports();
      }
    },
    handleOpenMedicalReport: function (link) {
      window.open(link, "_blank")
    }
  },
  created() {
    this.fetchDiversityOptionsRequest();
    this.fetchMedicalReports();
  },
};
</script>

<template>
  <div class="w-full flex flex-col items-center justify-center">
    <div class="w-full h-0 sm:h-12 flex"></div>
    <div class="card flex flex-col bg-white rounded max-w-sm w-full">
      <div class="flex flex-col w-full space-y-2">
        <button class="nxp-back-btn hidden sm:flex" @click="handleBackward">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <mask id="mask0_857_10485" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16"
              height="16">
              <rect width="16" height="16" fill="#696969" />
            </mask>
            <g mask="url(#mask0_857_10485)">
              <path
                d="M9.33362 11.7688L5.56445 7.99964L9.33362 4.23047L10.0361 4.93297L6.96945 7.99964L10.0361 11.0663L9.33362 11.7688Z"
                fill="#A9A9A9" />
            </g>
          </svg>
          Voltar
        </button>
        <span v-if="jobPositionReference" class="nxp-job-title">
          {{ jobPositionReference }}
        </span>
        <h1 class="nxp-title-form">
          Diversidade & Inclusão
        </h1>
        <span class="nxp-subtitle-form">
          Preencha seus dados para os recrutadores te conhecerem melhor
        </span>
      </div>

      <div class="flex w-full flex-col mt-8 mb-6 space-y-2">
        <div class="w-full flex flex-col space-y-6">

          <div class="w-full flex flex-col space-y-2">
            <label for="gender" class="nxp-label">
              Identidade de gênero
              <span> - Opcional</span>
            </label>
            <div class="flex w-full items-center space-x-2">
              <v-select id="gender" class="w-full" :options="options.genders" :reduce="(gender) => gender.value"
                v-model="payload.gender">
                <template v-slot:option="option">
                  <div class="gender">
                    <h2>{{ option.label }}</h2>
                    <p>{{ option.description }}</p>
                  </div>
                </template>
              </v-select>
              <div @click="handleOpenDiversity" class="flex w-full items-center space-x-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M9.37467 13.959H10.6247V9.16732H9.37467V13.959ZM9.99967 7.74107C10.1904 7.74107 10.3502 7.67655 10.4793 7.54753C10.6083 7.4185 10.6728 7.25864 10.6728 7.06794C10.6728 6.87725 10.6083 6.71739 10.4793 6.58836C10.3502 6.45947 10.1904 6.39503 9.99967 6.39503C9.80898 6.39503 9.64912 6.45947 9.52009 6.58836C9.39106 6.71739 9.32655 6.87725 9.32655 7.06794C9.32655 7.25864 9.39106 7.4185 9.52009 7.54753C9.64912 7.67655 9.80898 7.74107 9.99967 7.74107ZM10.0011 17.9173C8.90613 17.9173 7.8769 17.7095 6.91342 17.294C5.94995 16.8784 5.1119 16.3145 4.39926 15.6021C3.68662 14.8897 3.12238 14.052 2.70655 13.089C2.29085 12.1259 2.08301 11.097 2.08301 10.0021C2.08301 8.90711 2.29079 7.87787 2.70634 6.9144C3.1219 5.95093 3.68586 5.11287 4.39822 4.40023C5.11058 3.6876 5.94829 3.12336 6.91134 2.70753C7.8744 2.29183 8.90336 2.08398 9.99822 2.08398C11.0932 2.08398 12.1225 2.29176 13.0859 2.70732C14.0494 3.12287 14.8875 3.68683 15.6001 4.39919C16.3127 5.11155 16.877 5.94926 17.2928 6.91232C17.7085 7.87537 17.9163 8.90433 17.9163 9.99919C17.9163 11.0942 17.7086 12.1234 17.293 13.0869C16.8775 14.0504 16.3135 14.8884 15.6011 15.6011C14.8888 16.3137 14.0511 16.8779 13.088 17.2938C12.125 17.7095 11.096 17.9173 10.0011 17.9173ZM9.99967 16.6673C11.8608 16.6673 13.4372 16.0215 14.7288 14.7298C16.0205 13.4382 16.6663 11.8618 16.6663 10.0007C16.6663 8.13954 16.0205 6.56315 14.7288 5.27148C13.4372 3.97982 11.8608 3.33398 9.99967 3.33398C8.13856 3.33398 6.56217 3.97982 5.27051 5.27148C3.97884 6.56315 3.33301 8.13954 3.33301 10.0007C3.33301 11.8618 3.97884 13.4382 5.27051 14.7298C6.56217 16.0215 8.13856 16.6673 9.99967 16.6673Z"
                    fill="#4F4F4F" />
                </svg>
                <p class="nxp-explanation-popup-btn">Por que pedimos seu gênero?</p>
              </div>
            </div>
            <span class="error" v-show="errors.gender.length">{{ errors.gender }}</span>
          </div>

          <div class="w-full flex flex-col space-y-2">
            <label for="skin_color" class="nxp-label">
              Cor
              <span> - Opcional</span>
            </label>
            <div class="flex w-full items-center space-x-2">
              <v-select id="skin_color" class="w-full" :options="options.breeds" :reduce="(breed) => breed.value"
                v-model="payload.breed_id" />
              <div @click="handleOpenSkinColor" class="flex w-full items-center space-x-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M9.37467 13.959H10.6247V9.16732H9.37467V13.959ZM9.99967 7.74107C10.1904 7.74107 10.3502 7.67655 10.4793 7.54753C10.6083 7.4185 10.6728 7.25864 10.6728 7.06794C10.6728 6.87725 10.6083 6.71739 10.4793 6.58836C10.3502 6.45947 10.1904 6.39503 9.99967 6.39503C9.80898 6.39503 9.64912 6.45947 9.52009 6.58836C9.39106 6.71739 9.32655 6.87725 9.32655 7.06794C9.32655 7.25864 9.39106 7.4185 9.52009 7.54753C9.64912 7.67655 9.80898 7.74107 9.99967 7.74107ZM10.0011 17.9173C8.90613 17.9173 7.8769 17.7095 6.91342 17.294C5.94995 16.8784 5.1119 16.3145 4.39926 15.6021C3.68662 14.8897 3.12238 14.052 2.70655 13.089C2.29085 12.1259 2.08301 11.097 2.08301 10.0021C2.08301 8.90711 2.29079 7.87787 2.70634 6.9144C3.1219 5.95093 3.68586 5.11287 4.39822 4.40023C5.11058 3.6876 5.94829 3.12336 6.91134 2.70753C7.8744 2.29183 8.90336 2.08398 9.99822 2.08398C11.0932 2.08398 12.1225 2.29176 13.0859 2.70732C14.0494 3.12287 14.8875 3.68683 15.6001 4.39919C16.3127 5.11155 16.877 5.94926 17.2928 6.91232C17.7085 7.87537 17.9163 8.90433 17.9163 9.99919C17.9163 11.0942 17.7086 12.1234 17.293 13.0869C16.8775 14.0504 16.3135 14.8884 15.6011 15.6011C14.8888 16.3137 14.0511 16.8779 13.088 17.2938C12.125 17.7095 11.096 17.9173 10.0011 17.9173ZM9.99967 16.6673C11.8608 16.6673 13.4372 16.0215 14.7288 14.7298C16.0205 13.4382 16.6663 11.8618 16.6663 10.0007C16.6663 8.13954 16.0205 6.56315 14.7288 5.27148C13.4372 3.97982 11.8608 3.33398 9.99967 3.33398C8.13856 3.33398 6.56217 3.97982 5.27051 5.27148C3.97884 6.56315 3.33301 8.13954 3.33301 10.0007C3.33301 11.8618 3.97884 13.4382 5.27051 14.7298C6.56217 16.0215 8.13856 16.6673 9.99967 16.6673Z"
                    fill="#4F4F4F" />
                </svg>
                <p class="nxp-explanation-popup-btn">Por que pedimos sua cor?</p>
              </div>
            </div>
            <span class="error" v-show="errors.breed_id.length">{{ errors.breed_id }}</span>
          </div>

          <div class="flex flex-col space-y-2">
            <div class="flex flex-col space-y-2">
              <label for="is_egression" class="nxp-checkbox-container">
                <vs-checkbox id="is_egression" color="primary" v-model="payload.is_egression" />
                <p>
                  Sou pessoa egressa ou pré-egressa do sistema carcerário
                </p>
              </label>
              <p class="nxp-small-label">Opcional</p>

              <span class="error" v-show="errors.is_egression.length">{{ errors.is_egression }}</span>
            </div>
            <div @click="handleOpenEgression" class="flex flex-row items-center gap-2 py-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M9.37467 13.959H10.6247V9.16732H9.37467V13.959ZM9.99967 7.74107C10.1904 7.74107 10.3502 7.67655 10.4793 7.54753C10.6083 7.4185 10.6728 7.25864 10.6728 7.06794C10.6728 6.87725 10.6083 6.71739 10.4793 6.58836C10.3502 6.45947 10.1904 6.39503 9.99967 6.39503C9.80898 6.39503 9.64912 6.45947 9.52009 6.58836C9.39106 6.71739 9.32655 6.87725 9.32655 7.06794C9.32655 7.25864 9.39106 7.4185 9.52009 7.54753C9.64912 7.67655 9.80898 7.74107 9.99967 7.74107ZM10.0011 17.9173C8.90613 17.9173 7.8769 17.7095 6.91342 17.294C5.94995 16.8784 5.1119 16.3145 4.39926 15.6021C3.68662 14.8897 3.12238 14.052 2.70655 13.089C2.29085 12.1259 2.08301 11.097 2.08301 10.0021C2.08301 8.90711 2.29079 7.87787 2.70634 6.9144C3.1219 5.95093 3.68586 5.11287 4.39822 4.40023C5.11058 3.6876 5.94829 3.12336 6.91134 2.70753C7.8744 2.29183 8.90336 2.08398 9.99822 2.08398C11.0932 2.08398 12.1225 2.29176 13.0859 2.70732C14.0494 3.12287 14.8875 3.68683 15.6001 4.39919C16.3127 5.11155 16.877 5.94926 17.2928 6.91232C17.7085 7.87537 17.9163 8.90433 17.9163 9.99919C17.9163 11.0942 17.7086 12.1234 17.293 13.0869C16.8775 14.0504 16.3135 14.8884 15.6011 15.6011C14.8888 16.3137 14.0511 16.8779 13.088 17.2938C12.125 17.7095 11.096 17.9173 10.0011 17.9173ZM9.99967 16.6673C11.8608 16.6673 13.4372 16.0215 14.7288 14.7298C16.0205 13.4382 16.6663 11.8618 16.6663 10.0007C16.6663 8.13954 16.0205 6.56315 14.7288 5.27148C13.4372 3.97982 11.8608 3.33398 9.99967 3.33398C8.13856 3.33398 6.56217 3.97982 5.27051 5.27148C3.97884 6.56315 3.33301 8.13954 3.33301 10.0007C3.33301 11.8618 3.97884 13.4382 5.27051 14.7298C6.56217 16.0215 8.13856 16.6673 9.99967 16.6673Z"
                  fill="#4F4F4F" />
              </svg>
              <p class="nxp-explanation-popup-btn">Por que pedimos esta informação</p>
            </div>
          </div>

          <div class="w-full flex flex-col gap-2">
            <label for="gender" class="nxp-label">
              Possui algum tipo de deficiência?
              <span> - Opcional</span>
            </label>

            <div class="flex flex-col gap-2" :key="has_disabilities">
              <vs-radio class="nxp-checkbox-container" v-model="has_disabilities" vs-value="1" key="1">Sim</vs-radio>
              <vs-radio class="nxp-checkbox-container" v-model="has_disabilities" vs-value="0" key="0">Não</vs-radio>
            </div>
            
            <div v-if="has_disabilities === '1'" class="flex flex-col gap-2 mt-5">
              <div class="flex flex-col w-full items-center space-y-2" v-for="item in options.deficiency"
                :key="item.label">
                <label :for="item.value" class="nxp-checkbox-container">
                  <vs-checkbox :id="item.value" @click="onDisabilities(item.value)"
                    :checked="payload.disabilities_id.includes(item.value)">
                  </vs-checkbox>
                  <p>{{ item.label }}</p>
                </label>
              </div>
              <span class="error" v-show="errors.disabilities_id.length">{{ errors.disabilities_id }}</span>
              <div class="w-full flex flex-col space-y-2 mt-5">
                <label for="pcd_reability" class="nxp-checkbox-container">
                  <vs-checkbox id="pcd_reability" color="primary" v-model="payload.pcd_reability" />
                  <p>
                    Pessoa com deficiência reabilitada pelo INSS
                  </p>
                </label>

                <span class="error" v-show="errors.pcd_reability.length">{{ errors.pcd_reability }}</span>
              </div>
              <div class="w-full flex flex-col gap-5 py-4">
                <label class="nxp-label">
                  Laudo médico para PCD*
                </label>
                <p class="nxp-small-label">Anexar o laudo é essencial para que a empresa possa oferecer as adaptações necessárias no local de trabalho</p>
                <div class="w-full flex flex-col gap-2">
                  <div class="nxp-file-input-success" 
                      v-for="medical_report in medical_report_list" 
                      :key="medical_report.title"
                      @click="() => handleOpenMedicalReport(medical_report.link)"
                      style="cursor: pointer">
                    <div class="divider" :style="{ background: color }"></div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                      <g clip-path="url(#clip0_917_23314)">
                        <path
                          d="M7.51066 12.7765L12.0636 8.22334L11.198 7.35782L7.51901 11.0366L5.72203 9.21766L4.82596 10.0915L7.51066 12.7765ZM3.92878 16.0005C3.53273 16.0005 3.19916 15.8639 2.92809 15.5906C2.65702 15.3173 2.52148 14.9828 2.52148 14.5871V1.41345C2.52148 1.01769 2.65812 0.683173 2.93139 0.409904C3.20466 0.136635 3.53917 0 3.93494 0H10.7415L14.3021 3.56056V14.5871C14.3021 14.9828 14.1654 15.3173 13.892 15.5906C13.6186 15.8639 13.2838 16.0005 12.8878 16.0005H3.92878ZM9.90634 4.39575V1.14289H3.93494C3.86724 1.14289 3.80526 1.1711 3.749 1.22751C3.69258 1.28378 3.66438 1.34576 3.66438 1.41345V14.5871C3.66438 14.6548 3.69258 14.7167 3.749 14.773C3.80526 14.8294 3.86724 14.8576 3.93494 14.8576H12.8886C12.9563 14.8576 13.0183 14.8294 13.0746 14.773C13.131 14.7167 13.1592 14.6548 13.1592 14.5871V4.39575H9.90634Z"
                          :fill="color" />
                      </g>
                      <defs>
                        <clipPath id="clip0_917_23314">
                          <rect width="16" height="16" fill="white" transform="translate(0.412109)" />
                        </clipPath>
                      </defs>
                    </svg>
                    <p v-if="medical_report.title.length > 54">{{medical_report.title.substring(0,45)}}...{{medical_report.title.substring(medical_report.title.length -6,medical_report.title.length )}}</p>
                    <p v-else>{{medical_report.title}}</p>
                    <button @click.stop="() => removeMedicalReport(medical_report.uuid)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        <path
                          d="M7.16889 16.5841C6.79917 16.5841 6.48341 16.4533 6.2216 16.1916C5.95993 15.9298 5.8291 15.614 5.8291 15.2443V5.50076H4.8291V4.41742H8.41244V3.51367H12.4124V4.41742H15.9958V5.50076H14.9958V15.2353C14.9958 15.6206 14.8663 15.9417 14.6072 16.1987C14.3482 16.4556 14.0311 16.5841 13.656 16.5841H7.16889ZM13.9124 5.50076H6.91244V15.2443C6.91244 15.3192 6.93646 15.3806 6.98452 15.4287C7.03257 15.4767 7.09403 15.5008 7.16889 15.5008H13.656C13.7201 15.5008 13.7789 15.474 13.8322 15.4205C13.8857 15.3672 13.9124 15.3085 13.9124 15.2443V5.50076ZM8.7491 14.0008H9.83223V7.00076H8.7491V14.0008ZM10.9926 14.0008H12.0758V7.00076H10.9926V14.0008Z"
                          fill="#4F4F4F" />
                      </svg>
                      Excluir
                    </button>
                  </div> 
                </div>               
                <label v-if="medical_report_list.length === 0" class="nxp-file-input-group" for="medical_report_file">
                  <p><span>Anexar laudo</span><br />
                  Aceita png, jpg, jpeg, pdf, doc e docx até 15 MB</p>
                  <input class="nxp-file-input" id="medical_report_file" ref="medical_report_file" type="file"
                    accept="application/pdf,application/msword,.doc,.docx,.pdf" @change="handleMedicalReportUpload" />
                </label> 

              </div>
            </div>
          </div>
          <div @click="handleOpenPCD" class="flex flex-row items-center gap-2 py-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M9.37467 13.959H10.6247V9.16732H9.37467V13.959ZM9.99967 7.74107C10.1904 7.74107 10.3502 7.67655 10.4793 7.54753C10.6083 7.4185 10.6728 7.25864 10.6728 7.06794C10.6728 6.87725 10.6083 6.71739 10.4793 6.58836C10.3502 6.45947 10.1904 6.39503 9.99967 6.39503C9.80898 6.39503 9.64912 6.45947 9.52009 6.58836C9.39106 6.71739 9.32655 6.87725 9.32655 7.06794C9.32655 7.25864 9.39106 7.4185 9.52009 7.54753C9.64912 7.67655 9.80898 7.74107 9.99967 7.74107ZM10.0011 17.9173C8.90613 17.9173 7.8769 17.7095 6.91342 17.294C5.94995 16.8784 5.1119 16.3145 4.39926 15.6021C3.68662 14.8897 3.12238 14.052 2.70655 13.089C2.29085 12.1259 2.08301 11.097 2.08301 10.0021C2.08301 8.90711 2.29079 7.87787 2.70634 6.9144C3.1219 5.95093 3.68586 5.11287 4.39822 4.40023C5.11058 3.6876 5.94829 3.12336 6.91134 2.70753C7.8744 2.29183 8.90336 2.08398 9.99822 2.08398C11.0932 2.08398 12.1225 2.29176 13.0859 2.70732C14.0494 3.12287 14.8875 3.68683 15.6001 4.39919C16.3127 5.11155 16.877 5.94926 17.2928 6.91232C17.7085 7.87537 17.9163 8.90433 17.9163 9.99919C17.9163 11.0942 17.7086 12.1234 17.293 13.0869C16.8775 14.0504 16.3135 14.8884 15.6011 15.6011C14.8888 16.3137 14.0511 16.8779 13.088 17.2938C12.125 17.7095 11.096 17.9173 10.0011 17.9173ZM9.99967 16.6673C11.8608 16.6673 13.4372 16.0215 14.7288 14.7298C16.0205 13.4382 16.6663 11.8618 16.6663 10.0007C16.6663 8.13954 16.0205 6.56315 14.7288 5.27148C13.4372 3.97982 11.8608 3.33398 9.99967 3.33398C8.13856 3.33398 6.56217 3.97982 5.27051 5.27148C3.97884 6.56315 3.33301 8.13954 3.33301 10.0007C3.33301 11.8618 3.97884 13.4382 5.27051 14.7298C6.56217 16.0215 8.13856 16.6673 9.99967 16.6673Z"
                fill="#4F4F4F" />
            </svg>
            <p class="nxp-explanation-popup-btn">Por que perguntamos sua deficiência?</p>
          </div>

          <button class="nxp-continue-btn mt-16" :style="{ background: color }" @click="handleForward">{{ isEdit() ?
            "Salvar" :
            'Continuar' }}</button>
        </div>
      </div>
    </div>

    <vs-popup title="" :active.sync="diversity_popup">
      <div class="nxp-modal-content">
        <h2 class="nxp-modal-title mb-4">Por que pedimos seu gênero?</h2>
        <p class="nxp-modal-paragraph mb-8">
          Ao pedir sua identidade de gênero durante o processo seletivo, garantimos a <b>inclusão e diversidade</b> no
          ambiente
          de trabalho.<br /> <br />
          Além disso, isso pode ajudar a empresa a entender melhor a composição da sua força de trabalho, o que pode ser
          útil para estabelecer <b>políticas e programas que promovam a diversidade e inclusão</b>.
        </p>
        <button class="nxp-continue-btn" @click="handleCloseDiversity">Fechar</button>
      </div>
    </vs-popup>

    <vs-popup title="" :active.sync="skin_color_popup">
      <div class="nxp-modal-content">
        <h2 class="nxp-modal-title mb-4">Por que pedimos sua cor?</h2>
        <p class="nxp-modal-paragraph mb-8">
          Pedir a sua cor durante o processo seletivo é uma forma de coletar informações sobre a
          <b> diversidade étnico-racial </b>
          da empresa e do seu quadro de colaboradores.
          <br />
          <br />
          Isso permite que a empresa possa identificar eventuais desigualdades e lacunas em sua força de trabalho e, a
          partir dessas informações, desenvolver <b> políticas e ações afirmativas </b> para <b>promover a inclusão
            social
            e a diversidade</b> em seu ambiente de trabalho.
        </p>
        <button class="nxp-continue-btn" @click="handleCloseSkinColor">Fechar</button>
      </div>
    </vs-popup>

    <vs-popup title="" :active.sync="egression_popup">
      <div class="nxp-modal-content">
        <h2 class="nxp-modal-title mb-4">Por que perguntamos se você é uma pessoa egressa ou pré-egressa do sistema
          carcerário?</h2>
        <p class="nxp-modal-paragraph mb-8">
          Pessoa egressa é quem saiu recentemente da prisão e pré-egressa é quem ainda está cumprindo pena, mas está em
          processo de reintegração na sociedade.
          <br />
          <br />
          Coletar informações sobre essas pessoas no processo seletivo é importante para <b>promover a inclusão</b> e
          diversidade
          <b>no ambiente de trabalho</b>, além de contribuir para <b>reduzir preconceitos e discriminação</b>.
        </p>
        <button class="nxp-continue-btn" @click="handleCloseEgression">Fechar</button>
      </div>
    </vs-popup>

    <vs-popup title="" :active.sync="PCD_popup">
      <div class="nxp-modal-content">
        <h2 class="nxp-modal-title mb-4">
          Por que pedimos sua deficiência?
        </h2>
        <p class="nxp-modal-paragraph mb-8">
          Durante o processo de seleção, perguntamos se você tem alguma deficiência para garantir que nosso <b>ambiente
            de
            trabalho</b> seja <b>acessível</b> para todos.
          <br /> <br />
          Isso nos ajuda a cumprir a <b>lei de cotas</b> para pessoas com deficiência e a identificar quaisquer
          barreiras de
          acessibilidade que possam existir.
          <br /> <br />
          Uma <b> pessoa com deficiência reabilitada</b> é alguém que passou pelo processo de reabilitação pelo INSS com
          sucesso e
          foi considerada apta a retornar ao mercado de trabalho.
        </p>
        <button class="nxp-continue-btn" @click="handleClosePCD">Fechar</button>
      </div>
    </vs-popup>

    <vs-popup title="" :active.sync="medical_report_removal_popup">
      <div class="nxp-modal-content">
        <h2 class="nxp-modal-title mb-4">Confirmar exclusão de laudos médicos</h2>
        <p class="nxp-modal-paragraph mb-8">
          Você não selecionou nenhuma deficiência, mas há laudos médicos anexados. 
          <br /><br />
          <b>Todos os laudos médicos serão removidos</b> se você continuar. Esta ação não pode ser desfeita.
          <br /><br />
          Deseja continuar?
        </p>
        <div class="flex flex-row gap-2 justify-end">
          <button class="nxp-continue-btn" :style="{ background: '#6c757d' }" @click="cancelRemoveMedicalReports">Cancelar</button>
          <button class="nxp-continue-btn" :style="{ background: color }" @click="confirmRemoveMedicalReports">Sim, continuar</button>
        </div>
      </div>
    </vs-popup>

  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";

.pcd__container {
  margin-left: -6px;
}

.gender {
  $text-color: #172b4d;
  $font-family: Roboto;

  margin: 0.3125rem auto;

  h2 {
    color: $text-color;
    font-family: $font-family;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    /* 19.2px */
    letter-spacing: 0.32px;
  }

  p {
    color: $text-color;
    font-family: $font-family;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    /* 16.8px */
    letter-spacing: 0.28px;
    text-wrap: wrap;
    margin: 0.625rem 0;
  }
}

.error {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  margin-left: 5px;
}
</style>
